// extracted by mini-css-extract-plugin
export default {"authoriseMain":"Authorise_authoriseMain__+VX4r","authorise":"Authorise_authorise__-bP+j","fade":"Authorise_fade__ZqnzV"};